import React, { ReactNode } from "react";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";

import skLocale from "date-fns/locale/sk";
import enLocale from "date-fns/locale/en-US";

import { makeMessages } from "../../utils/makeMessages";



export type DatePickersProviderProps = {
	children: ReactNode;
};

export function DatePickersProvider(props: DatePickersProviderProps) {
	const {children} = props;
	const msgs = useMessages();
	
	return (
		<MuiPickersUtilsProvider
			utils={msgs.utils}
			locale={msgs.locale}
		>
			{children}
		</MuiPickersUtilsProvider>
	);
}


class LocalizedUtilsSK extends DateFnsUtils {
	getCalendarHeaderText(date: Date): string {
		return this.format(date, 'LLLL yyyy');
	}
}

const useMessages = makeMessages({
	utils: {
		sk: LocalizedUtilsSK,
		en: DateFnsUtils,
	},
	locale: {
		sk: skLocale,
		en: enLocale,
	}
})
